var map = {
	"./'21073101' , 2021, oil on canvas, 12 x 12 in. (30.48 x 30.48 cm), P.JPG": 8625,
	"./'Across the Water', 2025, oil on canvas, 15 x 30 in. (38.10 x 76.20 cm).jpeg": 9173,
	"./'After the Rain', 2024, oil on canvas, 9.45 x 12.99 in. (24 x 33 cm).JPG": 33,
	"./'Afterglow', 2026, oil on canvas, 10 x 30 in. (25.40 x 76.20 cm).jpeg": 6550,
	"./'Antique Picture', 2025, oil on canvas, 14 x 11 in. (35.56 x 27.94 cm), P.jpg": 212,
	"./'Babbling of the Stream', 2026, oil on canvas, 15 x 30 in. (38.10 x 76.20 cm).jpeg": 9988,
	"./'Barrington Afternoon Sky' , 2024, oil on canvas, 12 x 12 in. (30.48 x 30.48 cm).JPG": 6996,
	"./'Beautiful Day', 2025, oil on canvas, 30 x 40 in. (76.20 x 101.60 cm).jpeg": 8577,
	"./'Billowing Twilight', 2026, oil on canvas, 22 x 28 in. (55.88 x 71.12 cm).JPG": 943,
	"./'Breakthrough', 2025, oil on canvas, 24 x 30 in. (60.96 x 76.20 cm).jpg": 280,
	"./'By the pond' , 2024, oil on canvas, 12 x 12 in. (30.48 x 30.48 cm).JPG": 9736,
	"./'Calm Reflection', 2025, oil on canvas, 11 x 14 in. (27.94 x 35.56 cm), P.jpg": 5297,
	"./'Calm Twilight', 2026, oil on canvas, 12 x 36 in. (30.48 x 91.44 cm).jpeg": 1837,
	"./'Cloud Light' , 2025, oil on canvas, 30 x 24 in. (76.20 x 60.96 cm), P.jpeg": 5786,
	"./'Cloud stirring', 2026, oil on canvas, 40 x 30 in. (101.60 x 76.20 cm).jpeg": 542,
	"./'Cloudy Sunrise' , 2023, oil on canvas, 20 x 24 in. (50.8 x 60.96 cm), P.jpeg": 5027,
	"./'Crisp Autumn Day', 2025, oil on canvas, 15 x 30 in. (38.10 x 76.20 cm), P.JPG": 5339,
	"./'Curiosity', 2026, oil on canvas, 7 x 9 in. (17.78 x 22.86 cm).jpeg": 3097,
	"./'Early Spring in Illinois', 2025, oil on canvas, 9.45 x 12.99 in. (24 x 33 cm).jpg": 3440,
	"./'Early Summer', 2026, oil on canvas, 12 x 12 in. (30.48 x 30.48 cm), P.jpeg": 9133,
	"./'Energy of Hope', 2025, oil on canvas, 10 x 30 in. (25.40 x 76.20 cm).jpg": 2172,
	"./'Epiphany', 2026, oil on canvas, 16 x 20 in. (40.64 x 50.80 cm).jpeg": 6851,
	"./'Fall Colors', 2025, oil on canvas, 10 x 30 in. (25.40 x 76.20 cm), P.jpeg": 1179,
	"./'Fall Colors(2)', 2025, oil on canvas, 10 x 30 in. (25.40 x 76.20 cm), P.jpeg": 4412,
	"./'Field and Sky', 2023, oil on canvas, 36 x 36 in. (91.44 x 91.44 cm), P.jpeg": 7828,
	"./'Fields and Sky in Early Autumn' , 2024, oil on canvas, 24 x 24 in. (60.96 x 60.96 cm).jpeg": 6562,
	"./'Fiery Sky', 2025, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm).jpeg": 7241,
	"./'First Evening Star', 2025, oil on canvas, 15 x 30 in. (38.10 x 76.20 cm), P.jpeg": 8866,
	"./'Flowery Field' , 2024, oil on canvas, 24 x 24 in. (60.96 x 60.96 cm), P.JPG": 449,
	"./'Fresh Green Swamp', 2025, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm), P.JPG": 1826,
	"./'Glow of Late Autumn', 2026, oil on canvas, 10 x 30 in. (25.40 x 76.20 cm).jpeg": 225,
	"./'Glow of Late Summer', 2026, oil on canvas, 15 x 30 in. (38.10 x 76.20 cm).jpeg": 1742,
	"./'Going Home', 2024, oil on canvas, 9.45 x 12.99 in. (24 x 33 cm), P.JPG": 8061,
	"./'Golden Fields', 2025, oil on canvas, 15 x 30 in. (38.10 x 76.20 cm), P.jpeg": 9828,
	"./'Golden Sunrise', 2025, oil on canvas, 10 x 30 in. (25.40 x 76.20 cm), P.jpg": 2709,
	"./'Happiness', 2026, oil on canvas, 11 x 17 in. (27.94 x 43.18 cm).jpeg": 3998,
	"./'Heading Home', 2023, oil on canvas, 22 x 28 in. (55.88 x 71.12 cm), P.JPG": 2060,
	"./'Heavenly Meadow', 2025, oil on canvas, 14 x 11 in. (35.56 x 27.94 cm), P.jpg": 2426,
	"./'Hilltop View', 2025, oil on canvas, 40 x 30 in. (101.6 x 76.20 cm).jpeg": 1843,
	"./'Honest Reflection', 2025, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm), P.jpg": 6622,
	"./'Hope Rising' , 2025, oil on canvas, 8 x 10 in. (20.32 x 25.40 cm), P.jpeg": 549,
	"./'Indian Summer' , 2024, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm), P.JPG": 8738,
	"./'January Sunrise' , 2024, oil on canvas, 12 x 12 in. (30.48 x 30.48 cm), P.JPG": 4206,
	"./'Late Autumn Swamp', 2025, oil on canvas, 15 x 30 in. (38.10 x 76.20 cm), P.JPG": 3044,
	"./'Late Autumn', 2023, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm), P.JPG": 8645,
	"./'Late Winter Sky' , 2024, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm), P.JPG": 5594,
	"./'Lavender Clouds over the Marsh', 2024, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm), P.JPG": 9895,
	"./'Magical Sky', 2026, oil on canvas, 24 x 48 in. (60.96 x 121.92 cm).jpeg": 4550,
	"./'Midwinter Dusk', 2024, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm), P.JPG": 1208,
	"./'Midwinter Early Morning', 2024, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm), P.jpeg": 3416,
	"./'Mirrored Grace' , 2025, oil on canvas, 12 x 12 in. (30.48 x 30.48 cm).jpeg": 4138,
	"./'Misty Mountain View', 2025, oil on canvas, 15 x 30 in. (38.10 x 76.20 cm), P.jpeg": 914,
	"./'Morning Field', 2024, oil on canvas, 10 x 20 in. (25.40 x 50.80 cm).JPG": 3040,
	"./'Morning Starlight', 2025, oil on canvas, 10 x 20 in. (25.40 x 50.80 cm).jpeg": 6795,
	"./'Morning Waves', 2024, oil on canvas, 15 x 30 in. (38.10 x 76.20 cm), P.JPG": 5841,
	"./'Nature’s Beauty', 2026, oil on canvas, 14 x 14 in. (35.56 x 35.56 cm).jpeg": 8276,
	"./'Near Ellison Bay', 2023, oil on canvas, 24 x 24 in. (60.96 x 60.96 cm), P.JPG": 4782,
	"./'Near Sturgeon Bay' , 2024, oil on canvas, 24 x 24 in. (60.96 x 60.96 cm), P.JPG": 8254,
	"./'Near Wildcat Mountain' , 2023, oil on canvas, 24 x 36 in. (60.96 x 91.44 cm).jpeg": 4643,
	"./'New Horizon' , 2024, oil on canvas, 24 x 24 in. (60.96 x 60.96 cm).JPG": 1878,
	"./'One Spring Day' , 2023, oil on canvas, 12 x 12 in. (30.48 x 30.48 cm).JPG": 2983,
	"./'One Summer Day' , 2024, oil on canvas, 24 x 24 in. (60.96 x 60.96 cm), P.jpg": 9585,
	"./'Peaceful View' , 2024, oil on canvas, 14 x 14 in. (35.56 x 35.56 cm), P.JPG": 2335,
	"./'Perfect Blue', 2024, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm), P.JPG": 9587,
	"./'Perfect Sky', 2026, oil on canvas, 15 x 30 in. (38.10 x 76.20 cm), P.jpeg": 3175,
	"./'Purple Clouds', 2026, oil on canvas, 12 x 28 in. (30.48 x 71.12 cm).jpeg": 8460,
	"./'Purple Field', 2026, oil on canvas, 30 x 40 in. (76.20 x 101.60 cm).jpeg": 4055,
	"./'Quiet Clouds', 2026, oil on canvas, 12 x 36 in. (30.48 x 91.44 cm), P.jpeg": 5448,
	"./'Quiet Evening Walk', 2025, oil on canvas, 30 x 40 in. (76.20 x 101.60 cm), P.jpeg": 3417,
	"./'Quiet Winter Evening', 2024, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm), P.jpeg": 6621,
	"./'Quiet Winter Evening', 2025, oil on canvas, 15 x 30 in. (38.10 x 76.20 cm).jpeg": 8957,
	"./'Rolling Waves', 2025, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm).JPG": 1276,
	"./'Sea of Green', 2025, oil on canvas, 10 x 20 in. (25.40 x 50.80 cm), P.JPG": 4028,
	"./'Sea of Light', 2025, oil on canvas, 30 x 40 in. (76.20 x 101.60 cm), P.jpg": 8103,
	"./'Shadow's Edge', 2025, oil on canvas, 30 x 40 in. (76.20 x 101.60 cm).jpeg": 9299,
	"./'Sky Blues', 2025, oil on canvas, 30 x 40 in. (76.20 x 101.60 cm), P.jpeg": 9670,
	"./'Skylights', 2026, oil on canvas, 20 x 10 in. (50.80 x 25.40 cm).jpeg": 5994,
	"./'Snowy Beach Reflecting the Sun', 2025, oil on canvas, 10 x 30 in. (25.40 x 76.20 cm).jpeg": 6485,
	"./'Solitude', 2025, oil on canvas, 12 x 36 in. (30.48 x 91.44 cm).jpeg": 9584,
	"./'Spring Stroll', 2026, oil on canvas, 24 x 30 in. (60.96 x 76.20 cm).jpeg": 8443,
	"./'Summer Breeze' , 2023, oil on canvas, 20 x 20 in. (50.8 x 50.8 cm), P.JPG": 4526,
	"./'Sunlit Breeze', 2025, oil on canvas, 30 x 40 in. (76.20 x 101.60 cm).jpeg": 3356,
	"./'Sunny early summer day', 2026, oil on canvas, 15 x 30 in. (38.10 x 76.20 cm).JPG": 1440,
	"./'Sunrise Over Water' , 2024, oil on canvas, 20 x 16 in. (50.8 x 40.64 cm), P.JPG": 8415,
	"./'Sunrise over the Field', 2024, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm), P.JPG": 6964,
	"./'Sunset Peninsula', 2025, oil on canvas, 24 x 18 in. (60.96 x 45.72 cm).jpeg": 3035,
	"./'Sunset at Fish Creek', 2023, oil on canvas, 24 x 24 in. (60.96 x 60.96 cm).JPG": 9981,
	"./'Sunset in the Wind', 2025, oil on canvas, 10 x 30 in. (25.40 x 76.20 cm), P.jpeg": 5528,
	"./'Sunset on the Horizon', 2024, oil on canvas, 9.45 x 12.99 in. (24 x 33 cm).JPG": 7047,
	"./'Sunshine Tomorrow', 2025, oil on canvas, 12 x 36 in. (30.48 x 91.44 cm).jpeg": 1175,
	"./'Teal Reflection', 2026, oil on canvas, 24 x 48 in. (60.96 x 121.92 cm).jpeg": 7314,
	"./'The Perfect Spot' , 2025, oil on canvas, 6 x 8 in. (15.24 x 20.32 cm).jpeg": 3213,
	"./'Timberlake Sky', 2026, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm), P.jpeg": 4343,
	"./'Timberlake Sunset in July', 2025, oil on canvas, 10 x 20 in. (25.40 x 50.80 cm), P.jpeg": 3342,
	"./'Timberlake Sunset', 2024, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm), P.JPG": 1154,
	"./'Tranquillity', 2025, oil on canvas, 14 x 14 in. (35.56 x 35.56 cm), P.jpg": 3057,
	"./'Twilight Glow', 2025, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm), P.jpg": 4299,
	"./'Twilight Glow', 2026, oil on canvas, 40 x 30 in. (101.60 x 76.20 cm).jpeg": 9336,
	"./'Unexpected Light', 2025, oil on canvas, 10 x 20 in. (25.40 x 50.80 cm), P.jpeg": 7634,
	"./'Vast Sunset Sky', 2026, oil on canvas, 10 x 30 in. (25.40 x 76.20 cm).jpeg": 7348,
	"./'Warmth of the Sun', 2025, oil on canvas, 14 x 14 in. (35.56 x 35.56 cm), P.jpg": 2282,
	"./'Winter Pond', 2024, oil on canvas, 8 x 6 in. (20.32 x 15.24 cm), P.JPG": 7760,
	"./'Winter Sky', 2023, oil on canvas, 24 x 36 in. (60.96 x 91.44 cm).jpeg": 478,
	"./'Winter beach', 2024, oil on canvas, 12 x 24 in. (30.48 x 60.96 cm), P.JPG": 5246
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5747;